import { useEffect, useRef } from 'react';
import useAnalyticsContext from '|/hooks/use-analytics-context';

const usePurchaseHeaderEvent = () => {
  const { trackEvent } = useAnalyticsContext();

  const hasTrackedPageLoadRef = useRef(false);
  useEffect(() => {
    if (hasTrackedPageLoadRef.current) return;
    hasTrackedPageLoadRef.current = true;
    trackEvent('carvana-page-load');
  }, [trackEvent]);
};

export default usePurchaseHeaderEvent;
